import { diff, TimeUnit } from '../time';

export const getTimeframeTitle = (
  oldestReportSubmittedDate: Date,
  currentDate: Date = new Date(),
) => {
  const monthsDifference = diff(
    currentDate,
    oldestReportSubmittedDate,
    TimeUnit.months,
    true,
  );

  if (monthsDifference < 1) return 'the last month';

  if (monthsDifference <= 12) {
    return `the last ${Math.ceil(monthsDifference)} months`;
  }

  return `the last 12 months`;
};
